var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Pagination = function () {
    function Pagination() {
        _classCallCheck(this, Pagination);
    }

    _createClass(Pagination, [{
        key: "$onInit",
        value: function $onInit() {
            if (angular.isDefined(this.currentPage) && angular.isDefined(this.totalItems)) {
                this._updateFromTo();
            }
        }
    }, {
        key: "$onChanges",
        value: function $onChanges(changesObj) {
            if (changesObj.currentPage || changesObj.totalItems) {
                if (angular.isDefined(this.currentPage) && angular.isDefined(this.totalItems)) {
                    this._updateFromTo();
                }
            }
        }
    }, {
        key: "isLoaded",
        value: function isLoaded() {
            return angular.isDefined(this.totalItems);
        }
    }, {
        key: "hasPrevPage",
        value: function hasPrevPage() {
            return this.currentPage > 0;
        }
    }, {
        key: "loadPrevPage",
        value: function loadPrevPage() {
            if (this.hasPrevPage()) {
                this.onPageChange({
                    toPage: this.currentPage - 1,
                    pageSize: this.pageSize
                });
            }
        }
    }, {
        key: "hasNextPage",
        value: function hasNextPage() {
            return this.from + this.pageSize <= this.totalItems;
        }
    }, {
        key: "loadNextPage",
        value: function loadNextPage() {
            if (this.hasNextPage()) {
                this.onPageChange({
                    toPage: this.currentPage + 1,
                    pageSize: this.pageSize
                });
            }
        }
    }, {
        key: "_updateFromTo",
        value: function _updateFromTo() {
            this.from = this.currentPage * this.pageSize + 1;
            this.to = Math.min(this.from + (this.pageSize - 1), this.totalItems);
        }
    }]);

    return Pagination;
}();

export default Pagination;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/Pagination/Pagination.js
// module id = 1622
// module chunks = 0